module.exports = __webpack_public_path__ + "img/album18_32.0977b065.jpg";